import {
  DEFAULT_PRINT_PAGE_SIZE,
  PRINT_PAGE_SIZES,
} from 'constants/printPageSize';

// Layout tokens for the manifest template in utils/pdfGenerators.
// The manifest table is wide (11 columns), so both sizes are landscape.
const MANIFEST_PRINT_LAYOUTS = {
  [PRINT_PAGE_SIZES.LABEL_4X6]: {
    pageSize: '150mm 100mm',
    pageMargin: '5mm',
    bodyWidth: '140mm',
    bodyHeight: '90mm',
    bodyFontSize: '7px',
    cellFontSize: '6px',
    cellPadding: '1px',
    titleFontSize: '10px',
    headerFontSize: '8px',
    barcodeTextSize: '6px',
    barcodeHeight: 15,
    barcodeBarWidth: 0.8,
  },
  [PRINT_PAGE_SIZES.A4]: {
    pageSize: 'A4 landscape',
    pageMargin: '10mm',
    bodyWidth: '277mm',
    bodyHeight: null,
    bodyFontSize: '11px',
    cellFontSize: '10px',
    cellPadding: '3px',
    titleFontSize: '18px',
    headerFontSize: '12px',
    barcodeTextSize: '9px',
    barcodeHeight: 35,
    barcodeBarWidth: 1.2,
  },
};

export const getManifestPrintLayout = pageSize =>
  MANIFEST_PRINT_LAYOUTS[pageSize] ??
  MANIFEST_PRINT_LAYOUTS[DEFAULT_PRINT_PAGE_SIZE];
